<template>
    <div class="pl-navigator-main">
        <div class="pl-navigator-main-wrapper">
            <div class="pl-navigator-main-header-wrapper" v-if="!hideHeader">
                <div class="pl-navigator-main-header-slot-left">
                    <div class="pl-navigator-main-header">
                        <div :class="[
                            'pl-navigator-main-header-item',
                            'pl-navigator-main-header-item-gutter',
                            {'pl-navigator-main-header-item-prev':currentValue-1 === -1}
                        ]"></div>
                        <div class="pl-navigator-main-header-item"
                             v-for="(item,index) in pageStack"
                             :key="index"
                             :class="{
                            'pl-navigator-main-header-item-active':index === currentValue,
                            'pl-navigator-main-header-item-prev':index === currentValue-1,
                            'pl-navigator-main-header-item-next':index === currentValue+1,
                         }"
                             @click="p_clickTabTitle(index)"
                             @contextmenu.prevent="e=>p_contextMenu(e,item,index)">
                            <div class="pl-navigator-main-header-item-wrapper">
                                <div class="pl-navigator-main-header-item-inner">
                                    <span class="pl-navigator-main-header-item-label">
                                        <pl-tooltip-text :content="item.title"/>
                                    </span>
                                    <div class="pl-navigator-main-header-item-close-wrapper">
                                        <div class="pl-navigator-main-header-item-close" v-if="pageStack.length>1" @click.stop="p_close(item.id)">
                                            <link-icon icon="icon-close"/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="pl-navigator-main-header-item pl-navigator-main-header-item-empty"
                             :class="{'pl-navigator-main-header-item-next':currentValue === pageStack.length - 1}">
                        </div>
                    </div>
                </div>
                <div class="pl-navigator-main-header-slot">
                    <slot name="tab"></slot>
                </div>
            </div>

            <div class="pl-navigator-main-body">
                <pl-navigator-main-tab
                        ref="tabs"
                        v-for="(item,index) in pageStack"
                        :key="item.id"
                        :id="item.id"
                        :tab="item"
                        :before-push="beforePush"
                        :after-push="afterPush"
                        :get-page-component="p_getPageComponent"
                        :set-storage="p_setStorage"
                        :get-storage="p_getStorage"
                        v-if="item.init"
                        v-show="currentValue === index"
                        :disabled-storage="item.storage!=null?!item.storage:disabledStorage"

                        @refreshUrl="p_refreshUrl"/>
            </div>
        </div>
    </div>
</template>

<script>
    import {NAVIGATOR_CONSTANT, NavigatorTab} from "./index";
    import PlTooltipText from "../tooltip/pl-tooltip-text";
    import PlNavigatorMainTab from "./pl-navigator-main-tab";
    import {DocumentPage} from "../../doc-components";

    export default {
        name: "pl-navigator-main",
        components: {PlNavigatorMainTab, PlTooltipText,},
        props: {
            defaultPage: {type: Object},                                        //第一次默认打开的页面，格式{title, path, param, security}
            maxTabs: {type: Number, default: 20},                               //最大打开页签的个数
            beforeOpenTab: {type: Function},                                    //打开页签之前钩子函数
            afterOpenTab: {type: Function},                                     //打开页签之后的钩子函数
            beforePush: {type: Function},                                       //打开页面之前的钩子函数
            afterPush: {type: Function},                                        //关闭页面之后的钩子函数
            beforeOpenWindow: {type: Function},                                 //打开浏览器窗口页面之前的钩子函数
            afterOpenWindow: {type: Function},                                  //打开浏览器窗口页面之后的钩子函数
            idGenerator: {type: Function, required: true},                      //Tab页签id生成函数
            pageRegistryErrorHandler: {type: Function},                         //请求页面js文件出错处理
            page404: {type: String},                                            //找不到页面时，显示的404页面
            hideHeader: {type: Boolean},                                        //是否隐藏header
            storageKey: {type: String},                                         //多页面应用同时使用这个导航组件的话，缓存可能会冲突，这里未设置缓存的关键字，不同单页面应用的key应该不同
            showPathInUrl: {type: Boolean, default: true},                      //是否在地址栏显示页面路径
            disabledStorage: {type: Boolean},                                   //是否缓存页面历史
            openPreviousAfterInit: {type: Boolean, default: true},              //是否在初始化的时候打开旧的页面
        },
        data() {
            let pageStack = []
            /*从缓存中获取页面信息*/
            let selfStorage = this.p_getStorage(NAVIGATOR_CONSTANT.TAB)
            if (selfStorage.index != null && !!selfStorage.pageStack && selfStorage.pageStack.length > 0) {
                pageStack = selfStorage.pageStack.map((item) => Object.assign(item, {init: false}))
                !!this.openPreviousAfterInit && this.$nextTick(() => this.p_clickTabTitle(selfStorage.index))
            }
            return {
                pageStack,
                selfStorage,
                currentValue: null,
            }
        },
        created() {
            /*全局注入nav导航对象*/
            if (!!this.$lv.$tab) {
                this.$lv.$tab.$destroy()
                this.$lv.$tab = null
            }
            this.$lv.$tab = this

            /*打开默认页面*/
            if (this.pageStack.length === 0 && !!this.defaultPage) {
                this.p_openPage(this.defaultPage)
            }
        },
        computed: {
            classes() {
                return {}
            },
        },
        methods: {
            /**
             * 打开tab标签页
             * @author  韦胜健
             * @date    2019/2/26 16:27
             */
            async open(tab, refresh = false) {
                /*预处理*/
                tab = new NavigatorTab(tab)
                !!this.beforeOpenTab && (await this.beforeOpenTab(tab))
                if (!tab.id) tab.id = this.idGenerator(tab)
                if (!tab.id) return Promise.reject("打开Tab页时，id不能为空！")
                /*打开之前判断标签是否已经打开，已经打开则切换到标签页，判断标签页是否已经初始化，未初始化则加载页面*/
                let {page, pageIndex} = this.p_findPage(tab.id)
                if (page != null) {
                    if (!page.init) {
                        page.component = await this.p_getPageComponent(tab.path, tab.iframe)
                        page.init = true
                    }
                    Object.assign(page, tab)
                    if (refresh) await this.refresh(tab.id)
                    this.currentValue = pageIndex
                } else if (!!this.maxTabs && this.pageStack.length === this.maxTabs) {
                    // const msg = `最多只能打开${this.maxTabs}个页签！`
                    const msg = `已打开的页签过多,请关闭无用页签!`
                    this.$dialog.show(msg)
                    return Promise.reject(msg)
                } else {
                    /*打开新标签页*/
                    const pc = await this.p_getPageComponent(tab.path, tab.iframe)
                    if (!pc) return
                    page = Object.assign(tab, {component: pc, init: true})
                    /*防止卡主重复打开*/
                    if (!!this.$lv.$utils.findOne(this.pageStack, item => item.id === page.id && item.path === page.path && item.title === page.title)) return

                    this.pageStack.push(page)
                    await this.$lv.nextTick()
                    this.currentValue = this.pageStack.length - 1
                }
                !!this.afterOpenTab && (await this.afterOpenTab(page))
                this.p_save()
                this.$emit('openTab', page)
                this.p_refreshUrl()
                return page
            },
            /**
             * 关闭标签页
             * @author  韦胜健
             * @date    2019/2/26 16:33
             */
            async close(id) {
                return this.p_close(id)
            },
            /**
             * 刷新当前tab页面
             * @author  韦胜健
             * @date    2019/3/5 18:48
             */
            async refresh(id) {
                this.p_clearPage(id)

                /*重新初始化页面*/
                const {page} = this.p_findPage(id)
                if (this.pageStack.length === 0 || !page || !page.init) return
                page.init = false
                await this.$lv.nextTick()
                page.init = true
            },
            /**
             * 刷新某个tab的数据
             * @author  韦胜健
             * @date    2019/3/6 11:36
             */
            async update(id, newTabData) {
                const {page} = this.p_findPage(id)
                if (this.pageStack.length === 0 || !page) return
                Object.assign(page, newTabData)
                this.p_save()
                this.refresh(page.id)
            },
            /**
             * 获取当前显示的tab数据信息
             * @author  韦胜健
             * @date    2019/3/14 19:17
             */
            getCurrentTab() {
                // console.log(this.pageStack, this.currentValue)
                return this.pageStack.length > 0 && this.currentValue != null ? this.pageStack[this.currentValue] : null
            },
            /**
             * 显示页签
             * @author  韦胜健
             * @date    2019/9/25 17:11
             * @param   index   页签的index索引
             */
            async showTab(index) {
                if (index === this.currentValue && !!this.pageStack[index].init) return
                return await this.p_openPage(this.pageStack[index])
            },
            /**
             * 处理标签标题点击事件
             * @author  韦胜健
             * @date    2019/2/26 16:33
             */
            async p_clickTabTitle(index) {
                this.$emit('click-title', {page: this.pageStack[index], index})
                return this.showTab(index)
            },
            /**
             * 右击菜单
             * @author  韦胜健
             * @date    2019/3/6 17:10
             */
            async p_contextMenu(e, item, index) {
                let menuTarget = e.target;
                let count = 0
                while (!this.$lv.$dom.hasClass(menuTarget, 'pl-navigator-main-header-item') && count < 10) {
                    count++
                    menuTarget = menuTarget.parentNode
                }
                if (!!this.lv_select) {
                    await this.lv_select.hide()
                }
                this.lv_select = await this.$select.select({
                    data: this.pageStack.length > 1 ? ['刷新', '关闭', '关闭左侧页签', '关闭右侧页签', '关闭其他页签'] : ['刷新'],
                    reference: menuTarget,
                    popper: {height: null,},
                    onHide: () => this.lv_select = null,
                    onConfirm: (ret) => {
                        switch (ret) {
                            case '刷新':
                                this.refresh(item.id)
                                break
                            case '关闭':
                                this.close(item.id)
                                break
                            case '关闭左侧页签':
                                this.pageStack.forEach((itemPage, itemIndex) => itemIndex < index && (this.p_clearPage(itemPage.id)))
                                this.pageStack = this.pageStack.splice(index, this.pageStack.length)
                                this.p_openPage(this.pageStack[0])
                                break
                            case '关闭右侧页签':
                                this.pageStack.forEach((itemPage, itemIndex) => itemIndex > index && (this.p_clearPage(itemPage.id)))
                                this.pageStack = this.pageStack.splice(0, index + 1)
                                this.p_openPage(this.pageStack[index])
                                break
                            case '关闭其他页签':
                                this.pageStack.forEach((itemPage, itemIndex) => itemIndex !== index && (this.p_clearPage(itemPage.id)))
                                this.pageStack = this.pageStack.splice(index, 1)
                                this.p_openPage(this.pageStack[0])
                                break
                        }
                    }
                })
            },
            /**
             * 打开页面
             * @author  韦胜健
             * @date    2019/3/5 18:54
             */
            async p_openPage(page) {
                return this.open(page)
            },
            /**
             * 处理标签标题关闭事件
             * @author  韦胜健
             * @date    2019/2/26 16:33
             */
            async p_close(id) {
                if (this.pageStack.length === 1) {
                    this.$dialog.show("不能关闭所有页面！")
                    return
                }
                const {page, pageIndex} = this.p_findPage(id)
                if (page == null) return
                let index = pageIndex
                let nextIndex = this.currentValue
                if (index <= this.currentValue) nextIndex--;
                const closePage = this.pageStack.splice(index, 1)
                if (nextIndex < 0 && this.pageStack.length > 0) nextIndex = 0
                nextIndex > -1 && this.showTab(nextIndex)
                this.p_save()
                this.$emit('close', closePage)
                await this.refresh(id)
            },
            /**
             * 根据title以及path获取page的索引
             * @author  韦胜健
             * @date    2019/2/26 16:34
             */
            p_findPage(id) {
                const page = this.$lv.$utils.findOne(this.pageStack, (item) => item.id === id)
                const pageIndex = this.pageStack.indexOf(page)
                return {page, pageIndex}
            },
            /**
             * 根据id查找navigator-main-tab实例
             * @author  韦胜健
             * @date    2019/12/18 15:00
             */
            p_findPageInstance(id) {
                return this.$lv.$utils.findOne(this.$refs.tabs, tab => tab.id === id)
            },
            /**
             * 缓存当前页面信息
             * @author  韦胜健
             * @date    2019/2/26 16:34
             */
            p_save() {
                if (!!this.disabledStorage) return
                this.selfStorage.index = this.currentValue;
                this.selfStorage.pageStack = this.pageStack.map(item => NavigatorTab.getStorage(item))
                this.p_setStorage(NAVIGATOR_CONSTANT.TAB, this.selfStorage)
            },
            /**
             * 清除该页签的缓存
             * @author  韦胜健
             * @date    2019/3/6 17:47
             */
            p_clearPage(id) {
                const componentStorage = this.p_getStorage(NAVIGATOR_CONSTANT.PAGE)
                componentStorage[id] = null
                this.p_setStorage(NAVIGATOR_CONSTANT.PAGE, componentStorage)
            },
            /**
             * 获取页面组件对象
             * @author  韦胜健
             * @date    2019/3/8 17:53
             */
            async p_getPageComponent(path, iframe) {
                if (iframe) return 'link-navigator-iframe-page'
                return await this.p_pageRegistry(path)
            },
            /**
             * 自定义注册页面
             * @author  韦胜健
             * @date    2019/3/7 15:18
             */
            async p_pageRegistry(path) {
                if (!!DocumentPage[path]) return DocumentPage[path]
                try {
                    return await this.$lv.pageRegistry(path)
                } catch (e) {
                    console.info('找不到页面,转错误处理', e)
                    if (!!this.pageRegistryErrorHandler) await this.pageRegistryErrorHandler(path)
                    if (!!this.page404) return await this.$lv.pageRegistry(this.page404)
                    return Promise.reject(e.message)
                }
            },
            /**
             * 刷新浏览器地址栏地址
             * @author  韦胜健
             * @date    2019/4/2 11:28
             */
            async p_refreshUrl() {
                if (!this.showPathInUrl) return
                await this.$lv.$utils.delay(100)

                /*截取路径中的文件名*/
                function getPageName(path) {
                    let startIndex = path.lastIndexOf('/')
                    startIndex = startIndex == null ? 0 : startIndex
                    let endIndex = path.lastIndexOf('.')
                    endIndex = endIndex === -1 ? path.length : endIndex
                    return path.substring(startIndex + 1, endIndex)
                }
                /*获取路径所属模块*/
				function getPageModule(path) {
                  let reg = /\/(.+?)\//
				  if(reg.test(path)) {
				    return RegExp.$1.trim()
				  }
				  return ''
				}
                /*准备要拼接的url参数*/
                let appendParam = null

                if (!!this.disabledStorage) {
                    /*如果没有缓存，则通过实例变量查找*/
                    if (!this.pageStack[0]) return
                    const tabInstance = this.p_findPageInstance(this.pageStack[0].id)
                    if (!tabInstance) return

                    appendParam = {
                        menu: getPageName(this.pageStack[0].path),
                        page: getPageName(tabInstance.pageStack[0].path),
					  	module: getPageModule(tabInstance.pageStack[0].path)
                    }
                } else {
                    /*如果有缓存，则通过缓存参数查找*/
                    let tabStorage = this.p_getStorage(NAVIGATOR_CONSTANT.TAB)
                    let pageStorage = this.p_getStorage(NAVIGATOR_CONSTANT.PAGE)
                    const curTab = tabStorage.pageStack[this.currentValue]
                    const curPageStack = (pageStorage[curTab.id] || {}).pageStack || []
                    const curPage = curPageStack[curPageStack.length - 1] || {path: 'none'}

                    appendParam = {
                        menu: getPageName(curTab.path),
                        page: getPageName(curPage.path),
                     	module: getPageModule(curPage.path)
                    }
                }

                /*没有找到menu以及page直接返回*/
                if (!appendParam) {
                    return
                }

                const decodeData = this.$lv.$utils.decodeUrl(window.location.href.replace('#CRM', ''))
                if (!decodeData) return
                const {url, param} = decodeData
                window.history.pushState({}, null, this.$lv.$utils.encodeUrl(url, Object.assign(param, appendParam)))
			  	// window.LinkCurrentModule = appendParam.module
            },
            /**
             * 获取缓存
             * @author  韦胜健
             * @date    2019/3/11 19:23
             */
            p_getStorage(key) {
                let componentStorage = this.$lv.$storage.get(key) || {}
                return (!!this.storageKey ? componentStorage[this.storageKey] : componentStorage) || {}
            },
            /**
             * 设置缓存
             * @author  韦胜健
             * @date    2019/3/11 19:24
             */
            p_setStorage(key, value) {
                let componentStorage = this.$lv.$storage.get(key) || {}
                if (!!this.storageKey) {
                    componentStorage[this.storageKey] = value
                } else {
                    componentStorage = value
                }
                this.$lv.$storage.set(key, componentStorage)
            },

            /**
             * 派发事件
             * @author  韦胜健
             * @date    2019/3/19 18:51
             */
            emit(event, param) {
                this.$refs.tabs.forEach(tab => tab.listener.$emit(event, param))
            },
        },
        beforeDestroy() {
            // console.log('pl-navigator-main beforeDestroy')
            this.$delete(this.$lv, '$tab')
            this.$lv.$tab = null
        },
    }
</script>

<style lang="scss">

    @include themeify {
        $navigator-main-tab-border-color: #e8ebf7;
        $navigator-main-tab-border: solid 1px $navigator-main-tab-border-color;
        $navigator-main-tab-header-padding: 12px;
        $navigator-main-tab-background-color: #f0f2f7;
        $navigator-main-tab-head-radios: 10px;

        .pl-navigator-main {
            @include public-style;
            height: 100%;
            width: 100%;
            background-color: $navigator-main-tab-background-color;

            .pl-navigator-main-wrapper {
                box-sizing: border-box;
                display: flex;
                flex-direction: column;
                height: 100%;
                width: 100%;

                .pl-navigator-main-header-wrapper {
                    width: 100%;
                    display: flex;
                    justify-content: space-between;
                    height: 32px;
                    background: white;

                    .pl-navigator-main-header-slot-left {
                        background-color: transparent !important;
                        flex: 1;
                        overflow: hidden;
                        height: 100%;
                        box-sizing: border-box;
                        padding-right: 18px;

                        .pl-navigator-main-header {
                            height: 100%;
                            display: inline-flex;
                            align-items: center;
                            width: fit-content;
                            background-color: #F0F2F7;
                            max-width: 100%;
                            overflow: hidden;

                            .pl-navigator-main-header-item {
                                height: 100%;
                                font-size: 12px;
                                background-color: white;
                                cursor: pointer;
                                user-select: none;
                                box-sizing: border-box;
                                position: relative;
                                width: 150px;
                                color: rgba(0,0,0,0.45);

                                &.pl-navigator-main-header-item-gutter{
                                    width: 16px;
                                    &+.pl-navigator-main-header-item::before,&::before{
                                        border-left: none!important;
                                    }
                                }

                                &.pl-navigator-main-header-item-empty {
                                    cursor: default;
                                    width: 10px;
                                }

                                .pl-navigator-main-header-item-wrapper {
                                    height: 100%;
                                    display: flex;
                                    align-items: center;

                                    .pl-navigator-main-header-item-close-wrapper{
                                        position: absolute;
                                        padding: 4px 8px 0 0;
                                        width: 18px;
                                        height: 32px;
                                        right: 0;
                                        top:0;
                                        box-sizing: border-box;
                                        text-align: right;
										background-image: linear-gradient(270deg, #FFFFFF 0%, #FFFFFF 67%, rgba(255,255,255,0.00) 100%);
										border-radius: 0 $navigator-main-tab-head-radios 0 0;
                                    }

                                    .pl-navigator-main-header-item-close {
                                        display: inline-flex;
                                        align-items: center;
                                        justify-content: center;
                                        transform: scale(0.8);
                                        width: 24px;
                                        height: 24px;
                                        border-radius: 24px;
                                        opacity: 0;
                                        &:hover{
                                            background-color: $color-normal-border;
                                        }
                                    }

                                    .pl-navigator-main-header-item-label {
                                        width: 100%;
                                        overflow: hidden;
                                        text-overflow: ellipsis;
                                        position: relative;

                                        .pl-tooltip-text {
                                            text-align: left;
                                            text-overflow: initial;
                                        }
                                    }

                                    &:hover {
										.pl-navigator-main-header-item-close-wrapper{
											width: 36px;

										}
                                        .pl-navigator-main-header-item-close {
                                            opacity: 1;
                                        }
                                    }
                                }

                                &.pl-navigator-main-header-item-active {
                                    color: $color-primary;

                                    .pl-navigator-main-header-item-wrapper {
                                        background-color: #F0F2F7;
                                        border-top-left-radius: $navigator-main-tab-head-radios;
                                        border-top-right-radius: $navigator-main-tab-head-radios;
                                    }

                                    &::before {
                                        border-left: none !important;
                                    }

                                    .pl-navigator-main-header-item-close-wrapper {
										width: 36px;
										background-image: linear-gradient(270deg, #F0F2F7 0%, #F0F2F7 70%, rgba(240,242,247,0.00) 100%);
                                        border-radius: 0 10px 0 0;
                                    }
                                    .pl-navigator-main-header-item-close{
                                        opacity: 1;
                                        &:hover{
                                            color: #ffffff;
                                            background-color: $color-primary;
                                        }
                                    }
                                }

                                &.pl-navigator-main-header-item-prev {
                                    border-bottom-right-radius: $navigator-main-tab-head-radios;
                                    .pl-navigator-main-header-item-close-wrapper{
                                        border-radius: 0 0 10px 0;
                                    }
                                }

                                &.pl-navigator-main-header-item-next {
                                    border-bottom-left-radius: $navigator-main-tab-head-radios;

                                    &::before {
                                        border-left: none !important;
                                    }
                                }

                                .pl-navigator-main-header-item-inner {
                                    width: 100%;
                                    height: 100%;
                                    padding: 0 0 0 $navigator-main-tab-header-padding;
                                    display: flex;
                                    align-items: center;
                                    justify-content: space-between;
                                    white-space: nowrap;
                                    position: relative;
                                    box-sizing: border-box;
                                }

                                &::before {
                                    content: '';
                                    position: absolute;
                                    top: 8px;
                                    bottom: 8px;
                                    left: 0;
                                    right: 0;
                                    border-left: solid 1px #ddd;
                                }
                            }
                        }
                    }

                    .pl-navigator-main-header-slot {
                        width: 128px;
                        text-align: right;
                        flex-shrink: 0;
                    }
                }
            }

            .pl-navigator-main-body {
                margin: 16px;
                flex: 1;
                position: relative;
                box-sizing: border-box;
            }
        }
    }

    @media print {
        .pl-navigator-main-header-wrapper {
            display: none !important;
        }
        .pl-navigator-main-page {
            position: initial !important;
            top: initial !important;
            bottom: initial !important;
            left: initial !important;
            right: initial !important;
        }
        .pl-navigator-main, .pl-navigator-main-wrapper, .pl-navigator-main-body, .pl-navigator-main-tab, .pl-navigator-main-tab-wrapper, .pl-navigator-main-page, .pl-navigator-main-page-target {
            height: initial !important;
        }
        .pl-navigator-main-tab {
            position: initial !important;
            top: initial !important;
            bottom: initial !important;
            left: initial !important;
            right: initial !important;
        }
        .pl-navigator-main-body {
            display: block !important;
        }
        .pl-navigator-main {
            padding: 0 !important;
        }
        .pl-navigator-main-page:not(:last-child) {
            display: none !important;
        }
    }
</style>
